module.exports = __webpack_public_path__ + "img/courier-trexity.b68b334e.svg";